import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityLayout,
} from '@backstage/plugin-catalog';
import {
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import { entityWarningContent } from './EntityWarningContent';
import { CloudAppEnvironmentsContent } from './CloudAppEnvironmentsContent';
import {
  EntityGithubInsightsContent,
} from '@roadiehq/backstage-plugin-github-insights';
import {
  EntityGithubPullRequestsContent,
  isGithubPullRequestsAvailable,
} from '@roadiehq/backstage-plugin-github-pull-requests';
import {
  EntityGithubActionsContent,
  isGithubActionsAvailable,
} from '@backstage-community/plugin-github-actions';

const cloudAppOverviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} relations={['hasOrg', 'hasEnv']} />
    </Grid>
  </Grid>
);

export const cloudAppPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {cloudAppOverviewContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/environments" title="Environments">
      <CloudAppEnvironmentsContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/code-insights" title="Code Insights">
      <EntityGithubInsightsContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/pull-requests" title="Pull Requests" if={isGithubPullRequestsAvailable}>
      <EntityGithubPullRequestsContent />
    </EntityLayout.Route>
    <EntityLayout.Route path="/github-actions" title="GitHub Actions" if={isGithubActionsAvailable}>
      <EntityGithubActionsContent />
    </EntityLayout.Route>
  </EntityLayout>
);